<div class="tw-page-header-title__left">
  <!-- optional leading icon chip — content projected so the component
       stays icon-system agnostic ([slot=icon]) -->
  <span class="tw-page-header-title__icon" aria-hidden="true">
    <ng-content select="[slot=icon]"></ng-content>
  </span>

  <div class="tw-page-header-title__main">
    @if (editing()) {
      <span class="tw-page-header-title__edit">
        <input
          #titleInput
          class="tw-page-header-title__input"
          [class.tw-page-header-title__input--dirty]="dirty()"
          [value]="draft()"
          (input)="onDraftInput($any($event.target).value)"
          (keydown)="onKeydown($event)"
          aria-label="Edit title" />
        <tw-icon-btn
          class="tw-page-header-title__edit-btn"
          size="sm"
          variant="ghost"
          aria-label="Save (Enter)"
          (click)="commit()">
          <svg viewBox="0 0 16 16" width="100%" height="100%" fill="none" stroke="currentColor"
            stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3.5 8.5l3 3 6-6.5" />
          </svg>
        </tw-icon-btn>
        <tw-icon-btn
          class="tw-page-header-title__edit-btn"
          size="sm"
          variant="ghost"
          aria-label="Cancel (Esc)"
          (click)="cancel()">
          <svg viewBox="0 0 16 16" width="100%" height="100%" fill="none" stroke="currentColor"
            stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" />
          </svg>
        </tw-icon-btn>
        @if (dirty()) {
          <span class="tw-page-header-title__dirty-flag">Unsaved</span>
        }
      </span>
    } @else {
      <!-- Static (or not-yet-editing) heading. When `title()` is set it
           renders as text; otherwise projected default content fills the
           H1 so legacy projection-style usage keeps working. -->
      <h1 class="tw-page-header-title__heading">
        @if (title()) {
          {{ title() }}
        } @else {
          <ng-content></ng-content>
        }
      </h1>
      @if (editable()) {
        <tw-icon-btn
          class="tw-page-header-title__edit-btn"
          size="sm"
          variant="ghost"
          aria-label="Rename"
          (click)="enterEdit()">
          <svg viewBox="0 0 16 16" width="100%" height="100%" fill="none" stroke="currentColor"
            stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M11.2 2.8a1.4 1.4 0 0 1 2 2L5.5 12.5 2.5 13.5l1-3z" />
          </svg>
        </tw-icon-btn>
      }
    }

    <!-- adornment slot — outline badges / chips / live-indicator pulse -->
    <span class="tw-page-header-title__adornment">
      <ng-content select="[slot=title-adornment]"></ng-content>
    </span>
  </div>
</div>

<!-- actions slot — primary buttons / overflow, right-aligned (inline) or
     stacked below the title (twoTier) -->
<span class="tw-page-header-title__actions">
  <ng-content select="[slot=actions]"></ng-content>
</span>
